import * as React from "react";
import { useLocation } from "react-router-dom";

import { isViewportLockedListPage } from "@/lib/listViewPersistence";

const MOBILE_BREAKPOINT = 768;

function readIsMobile(): boolean {
  if (typeof window === 'undefined') return true;
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(readIsMobile);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => setIsMobile(readIsMobile());
    mql.addEventListener('change', onChange);
    onChange();
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

/**
 * Desktop list/detail pages: pin filters + scroll only the table panel.
 * Mobile: same as Dashboard — fixed app header, main column scrolls.
 */
export function useViewportLockedListPage(): boolean {
  const { pathname, search } = useLocation();
  const isMobile = useIsMobile();
  return isViewportLockedListPage(pathname, search) && !isMobile;
}
